module.exports = __webpack_public_path__ + "static/canaith_mandolin-4759f27e35cc72614288dca6015380cb.jpg";